import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Select, Store } from '@ngxs/store';
import { DeletePractitionerGroup, GetPractitionerGroups, NetworkMember, PractitionerGroupEntity, PractitionerGroupStateModel, GetTeamWorkHours, SchedulingStateModel, TeamWorkingHours, DayOfWeek, Time, secondsToDayTime, GetTeamMembers, TeamMember } from 'huddyapi';

import moment_ from 'moment';
import { Observable, Subscription } from 'rxjs';
import { ConfirmationDialog } from '../../components/confirmation-dialog/confirmation-dialog.component';
import { DocumentsDialog } from '../../components/documents/documents-dialog';
import { EditPractitionerGroupDialog } from '../../components/edit-practitioner-group-dialog/edit-practitioner-group-dialog.component';
import { SavedProvider } from '../settings.component';
import { CommunityConfigService } from '../../services/community-config.service';


const moment = moment_;

@Component({
  selector: 'practitioner-groups',
  templateUrl: './practitionerGroups.component.html',
  styleUrls: ['./practitionerGroups.component.scss']
})
export class PractitionerGroupsComponent implements OnInit {

  @Input() provider : SavedProvider;
  @Select(state => state.practitionerGroupState) practitionerGroupState$;
  @Select(state => state.schedulingState) schedulingState$: Observable<SchedulingStateModel>;
  practitionerGroupSubscription : Subscription;
  schedulingStateSubscription : Subscription;
  groups : PractitionerGroupEntity[];
  teamWorkingHours : TeamWorkingHours[];
  teamMembers : TeamMember[];

  constructor(
    private store : Store,
    public dialog: MatDialog,
    public matIconRegistry : MatIconRegistry,
    private domSanitizer : DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon('lib_books',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/library_books.svg'));

  }

  ngOnInit(): void {
    this.  practitionerGroupSubscription  = this.practitionerGroupState$.subscribe((practitionerGroupState: PractitionerGroupStateModel) => {
      console.log(practitionerGroupState);
      if (practitionerGroupState && practitionerGroupState.groups) {
         this.groups = [].concat(practitionerGroupState.groups);
      }
      console.log(this.groups, this.groups.map(g => g.name));   
    });
    this.  schedulingStateSubscription  = this.schedulingState$.subscribe((schedulingState: SchedulingStateModel) => {
      console.log(schedulingState);
      if (schedulingState ) {
        if (schedulingState.workingHours) {
            this.teamWorkingHours = [].concat( schedulingState.workingHours);
        }
        if (schedulingState.teamMembers) {
          this.teamMembers = [].concat( schedulingState.teamMembers);
        }
      }
      console.log(this.teamWorkingHours);   
    });
    console.log(this.provider);
    this.store.dispatch(new GetPractitionerGroups(this.provider.id));


  }

  getColorFromName(name : string, fromPatient? :boolean) : string {
    let ret : string = '#DAC7FD';
    if (name) {
      ret = NetworkMember.getColorForName(name);
      if (ret === 'avatarColor0') {
        ret = '#DAC7FD';
      } else if (ret === 'avatarColor1') {
        ret = '#F06D82';
      } else if (ret === 'avatarColor2') {
        ret = '#75C5EC';
      } else if (ret === 'avatarColor3') {
        ret = '#A7C2EF';
      }
    }
    return ret;
  }

  showDocuments(group : PractitionerGroupEntity) {

    let data = {
      contextId : group.id,
      contextType : 'PRACTICE_GROUP'
    }

    this.dialog.open(DocumentsDialog, {
      width: '600px',
      height: '500px',
      data: data
    });
  }

  onEdit(data : any) {
    console.log(data);

    if (data === null) {
      //add
      data = {
        id: -1,
        provider : this.provider,
        users : [],
        workDays : ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'],
        startTime : '9am',
        endTime: '5pm',
        holidays: [],
        coordinator : '',
        teamMembers : []
      }
      this.dialog.open(EditPractitionerGroupDialog, {
        width: '600px',
        height: '600px',
        data: data
      });
    } else {
      this.store.dispatch(new GetTeamWorkHours(data.id)).subscribe(action => {
        this.store.dispatch(new GetTeamMembers(data.id)).subscribe(action2 => {
          if (this.teamWorkingHours && this.teamMembers) {
            let workdays : string[] = this.teamWorkingHours
                      .filter(t => t.dayOfWeek != null)
                      .map(t => DayOfWeek[t.dayOfWeek]);
            let holidays = this.teamWorkingHours
                      .filter(t => t.epochDay != null && t.epochDay > 0)
                      .map(t => new Date((t.epochDay + 1) * 86400000)) ;
            let startTime : string = secondsToDayTime(this.teamWorkingHours
                      .filter(t => t.startTimeSecs != null)[0].startTimeSecs);
            let endTime : string = secondsToDayTime(this.teamWorkingHours
                        .filter(t => t.endTimeSecs != null)[0].endTimeSecs);  
            let coordinator : string = '';        
            let coordinatorTeamMember = this.teamMembers.filter(tm => tm.teamRole === 'COORDINATOR');      
            if (coordinatorTeamMember.length > 0) {      
              let coordinatorUsers : string[] = this.provider.savedUsers.filter(u => u.email === coordinatorTeamMember[0].email).map(u => u.email);
              if (coordinatorUsers.length > 0) {
                coordinator = coordinatorUsers[0];
              }
            }                                         
            data = {
              id : data.id,
              name : data.name,
              description : data.description,
              provider : this.provider,
              users : [].concat(data.providerUsers),
              workDays : workdays,
              startTime : startTime,
              endTime: endTime,
              holidays: holidays,
              coordinator: coordinator,
              teamMembers: this.teamMembers,
              families : [].concat(data.families)
            };
            console.log('Teams', 'data', data);
            this.dialog.open(EditPractitionerGroupDialog, {
              width: '600px',
              height: '600px',
              data: data
            });
          } else {
          console.error('Team working hours not initialized');
          }
        });
      });
    
    }
   
  }

  onDelete(group : PractitionerGroupEntity) {
    this.dialog.open(ConfirmationDialog, {
      width: '636px',
      data: {
        minWidth: '127px',
        title: 'Delete ' + group.name,
        body: 'Are you sure you want to delete ' + group.name + '?',
        buttons: [
          {
            text: 'Cancel',
            class: 'secondary',
            handler: (): boolean => {
              return false;
            }
          },
          {
            text: 'Confirm',
            class: '',
            handler: () => {
              this.store.dispatch(new DeletePractitionerGroup(group.id)).subscribe(r => {
                this.store.dispatch(new GetPractitionerGroups(this.provider.id));
              });
            }
          }
        ]
      }
    });
  }

  isCommunity() : boolean {
    return CommunityConfigService.isCommunity;
  }

  getFamiliesLength(group : PractitionerGroupEntity) : number {
    let ret : number = 0;
    if (this.isCommunity()) {
      if (group && group.families) {
        ret = group.families.length;
      }
    }
    return ret;
  }
}